import { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import "./SiswaLayout.css";

export default function SiswaLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  let siswa = {};

  try {
    const userData = localStorage.getItem("user");
    siswa = userData ? JSON.parse(userData) : {};
  } catch (error) {
    console.error("Data user tidak valid:", error);
    siswa = {};
  }

  const menuItems = [
    {
      label: "Dashboard",
      path: "/dashboard-siswa",
      icon: "🏠",
    },
    {
      label: "Data Diri",
      path: "/siswa/data-diri",
      icon: "👤",
    },
    {
      label: "Jadwal",
      path: "/siswa/jadwal",
      icon: "📅",
    },
    {
      label: "Nilai",
      path: "/siswa/nilai",
      icon: "📊",
    },
    {
      label: "Absensi",
      path: "/siswa/absensi",
      icon: "✅",
    },
    {
      label: "Pembayaran",
      path: "/siswa/pembayaran",
      icon: "💳",
    },
    {
      label: "Pengumuman",
      path: "/siswa/pengumuman",
      icon: "📢",
    },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user_id");
    localStorage.removeItem("siswa");
    localStorage.removeItem("siswa_id");

    setIsMenuOpen(false);
    navigate("/login", { replace: true });
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className="siswa-layout">
      <div
        className={`mobile-menu-overlay ${isMenuOpen ? "show" : ""}`}
        onClick={closeMenu}
      />

      <aside className={`siswa-sidebar ${isMenuOpen ? "mobile-open" : ""}`}>
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <div className="brand-logo">B</div>

            <div className="brand-text">
              <h2>BIMBELKU</h2>
              <p>Portal Siswa</p>
            </div>
          </div>

          <button
            type="button"
            className="mobile-close-btn"
            onClick={closeMenu}
            aria-label="Tutup menu"
          >
            ✕
          </button>
        </div>

        <div className="sidebar-profile">
          <div className="profile-avatar">
            {(siswa.nama || siswa.name || "S").charAt(0).toUpperCase()}
          </div>

          <div className="profile-info">
            <h3>{siswa.nama || siswa.name || "Siswa"}</h3>

            <p>{siswa.email || "siswa@bimbelku.com"}</p>
          </div>
        </div>

        <nav className="sidebar-menu">
          {menuItems.map((item) => {
            const isActive =
              location.pathname === item.path ||
              location.pathname.startsWith(`${item.path}/`);

            return (
              <button
                type="button"
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                className={isActive ? "active" : ""}
              >
                <span className="menu-icon">{item.icon}</span>

                <span className="menu-label">{item.label}</span>
              </button>
            );
          })}
        </nav>

        <button type="button" className="logout-btn" onClick={logout}>
          <span>🚪</span>
          <span className="logout-text">Logout</span>
        </button>
      </aside>

      <header className="mobile-topbar">
        <div className="mobile-brand">
          <div className="mobile-brand-logo">B</div>

          <div className="mobile-brand-text">
            <strong>BIMBELKU</strong>
            <small>Portal Siswa</small>
          </div>
        </div>

        <button
          type="button"
          className="mobile-menu-btn"
          onClick={toggleMenu}
          aria-label="Buka menu"
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? "✕" : "☰"}
        </button>
      </header>

      <main className="siswa-main">
        <Outlet />
      </main>
    </div>
  );
}
